import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";

type GetInvestmentsGroupedOptions = {
  archived?: boolean;
  allUsers?: boolean;
  enabled?: boolean;
};

export default function useGetInvestmentsGrouped(
  archivedOrOptions: boolean | GetInvestmentsGroupedOptions = false,
) {
  const archived =
    typeof archivedOrOptions === "boolean"
      ? archivedOrOptions
      : !!archivedOrOptions.archived;
  const allUsers =
    typeof archivedOrOptions === "boolean" ? false : !!archivedOrOptions.allUsers;
  const enabled =
    typeof archivedOrOptions === "boolean"
      ? true
      : (archivedOrOptions.enabled ?? true);

  const params = {
    ...(archived ? { archived: true } : {}),
    ...(allUsers ? { allUsers: true } : {}),
  };

  return useQuery({
    queryKey: ["investments/grouped", { archived, allUsers }],
    queryFn: async () => {
      return axiosInstance
        .get("/investments/grouped", {
          params: Object.keys(params).length ? params : undefined,
        })
        .then((res) => res.data);
    },
    retry: false,
    enabled,
    staleTime: 1000 * 30,
  });
}
